import React, { useState, useRef, useEffect } from 'react'
import {
  Grid, LinearProgress, MenuItem, DialogTitle, DialogContent, DialogActions, Button, Dialog,
  FormControl, Select, Box, Typography,
} from '@mui/material'
import stylesheet from '../detail-container.stylesheet'
import { ClassNameMap, withStyles } from '@mui/styles'
import Draggable from "react-draggable"
import DialogTitleHeaderComponent from '../common/dialog-title-header.component'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { PatientService } from '../../../../services/patient.service'
import Helper from '../../../../utils/helper'
import { toast } from 'react-toastify'
import { useUpdateDataAction } from '../../../../utils/update-details-hook'

interface IProps {
  open: boolean,
  input: any,
  handleDialogClose: any,
  classes: ClassNameMap
}

const UpdateDiagnosisStatusComponent: React.FC<IProps> = ({ open, input, handleDialogClose, classes }) => {
  const diagnosisRef = useRef(null) as any
  const [isLoading, setIsLoading] = useState(false)
  const [diaStatus, setDiaStatus] = useState(input?.diagnosis_status || '') as any
  const [testsList, setTestsList] = useState([]) as any
  const patientDetail = useSelector((state: RootState) => state.patientDetail.patientDetail)
  const patientService = new PatientService()
  const { updatePatientData } = useUpdateDataAction(patientDetail.id)

  useEffect(() => {
    getDiagnosisStatusList()
    setDiaStatus(input?.diagnosis_status)
  }, [input])

  const getDiagnosisStatusList = () => {
    if (input.program) {
      setIsLoading(true)
      patientService.getDiagnosticStatus(input.program).then((res: any) => {
        setTestsList(res?.data?.diagnosis || [])
      }).catch((error: any) => {
        toast.error(Helper.getError(error), Helper.bottom_center())
      }).finally(() => setIsLoading(false))
    }
  }

  const handleSubmit = () => {
    if (diaStatus && input.dId && input?.patientId) {
      let payload = { "diagnosis_status": diaStatus } as any
      patientService.putDiagnosisStatus(input?.patientId, input.dId, payload).then((res: any) => {
        if (res?.data)
          updatePatientData({ isMeasurement: true, isTreatments: true, isConditions: true })
        handleDialogClose()
        setIsLoading(false)
      }).catch((error: any) => {
        setIsLoading(false)
        handleDialogClose()
        toast.error(Helper.getError(error), Helper.bottom_center())
      })
    }
  }

  const isDisabled = () => {
    return diaStatus === '' || isLoading
  }

  const renderAddTest = () => {
    return <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant='subtitle2' className={classes.taskInput}>Status</Typography>
        <FormControl className={classes.formControlStage}>
          <Select
            id="test-type"
            labelId="add-test-label"
            variant="standard"
            value={diaStatus}
            onChange={(e) => setDiaStatus(e?.target?.value)}
            sx={{ width: '8rem !important' }}
            inputProps={{ classes: { icon: classes.icon, } }}
          >
            {testsList && testsList
              ?.sort((a: any, b: any) => a.toLowerCase() > b.toLowerCase() ? 1 : -1)
              ?.map((i: any) =>
                <MenuItem key={i} value={i} className={classes.programMenu}>
                  {i}
                </MenuItem>
              )}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  }

  return (
    <Draggable ref={diagnosisRef} defaultPosition={{ x: 0, y: 0 }} handle='.add-test-dialog'>
      <Dialog
        id={'add-test'}
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="Add test"
        hideBackdrop
        disableScrollLock
        onKeyUp={(e) => {
          e.preventDefault();
          if (e.key === 'Enter' && !isDisabled())
            handleSubmit()
        }}
        sx={{ position: "absolute", left: '15%', }}
      >
        <DialogTitle className={classes.addPatientQuestionHeaderSection} classes={{ root: 'add-test-dialog' }}>
          <DialogTitleHeaderComponent title={input.title} handleDialogClose={handleDialogClose} />
        </DialogTitle>
        <Box> {isLoading && <LinearProgress />} </Box>
        <DialogContent className={classes.addPatientDialogContent} sx={{ padding: '1rem 0.5rem 0.5rem 1.8rem' }}>
          {renderAddTest()}
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2} className={classes.containerPadding} justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                disabled={isDisabled()}
                onClick={handleSubmit}
                component="label"
              >
                Submit
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                onClick={handleDialogClose}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Draggable>
  );
};

export default withStyles(stylesheet)(UpdateDiagnosisStatusComponent)
